import { useLayoutEffect, useState } from 'react';

export const useRerenderAtLeastOnce = () => {
  const [, triggerRerender] = useState(false);

  useLayoutEffect(() => {
    triggerRerender(true);
  }, []);
};
